"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginStatusEndpoint = exports.logoutEndpoint = exports.loginEndpoint = void 0;
var routes_1 = require("~shared/utils/routes");
exports.loginEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/auth/login',
    method: 'post'
});
exports.logoutEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/auth/logout',
    method: 'get'
});
exports.loginStatusEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/auth/status',
    method: 'get'
});
//# sourceMappingURL=auth.js.map